export enum PermissionEnum {
  READ_EVENTS = 0,
  READ_USERS = 1,
  DELETE_USER = 2,
  CREATE_USER_ROLE = 3,
  LOGIN_AS_OTHER_USER = 4,

  /* Change another user's password  */
  CHANGE_PASSWORD_USER = 5,

  /* Update another user's information */
  UPDATE_USER = 6,
  CONFIGURATION = 7,
  CONFIGURATION_PLAN_SERVICE_EDIT = 8,
  CONFIGURATION_PLAN_SERVICE_DELETE = 9,
  CONFIGURATION_PLAN_SERVICE_ADD = 10,
  CONFIGURATION_ARTIST_TYPE_EDIT = 11,
  CONFIGURATION_ARTIST_TYPE_DELETE = 12,
  CONFIGURATION_ARTIST_TYPE_ADD = 13,
  CONFIGURATION_LANGUAGE_EDIT = 14,
  CONFIGURATION_LANGUAGE_DELETE = 15,
  CONFIGURATION_LANGUAGE_ADD = 16,

  READ_BOOKINGS = 17,
}
